import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function CollectionLab(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [labData, setLabData] = useState([]);
    const [iplabData, setIpLabData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchData();
        fetchIpData();
    }, [startDate, endDate]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}lab-collection-view/?start_date=${startDateString}&end_date=${endDateString}`;
        axios.get(url)
            .then(response => {
                setLabData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const rows = labData.filter(item => item.lab_paid > 0).map(item => ({
        id: item.id,
        date_time: `${item.add_date_date} ${item.add_time}`,
        appt_id: item.appt_id,
        pat__pat_id: item.pat__pat_id,
        pat__patient: item.pat__patient,
        lab_invoice: item.lab_invoice,
        lab_tot: item.lab_tot,
        lab_paid: item.lab_paid,
        lab_balance: item.lab_balance,
        lab_pmode: item.lab_pmode,
        cashier: item.cashier,
    }));
    function fetchIpData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}ip-lab-collection-view/?start_date=${startDateString}&end_date=${endDateString}`;
        axios.get(url)
            .then(response => {
                setIpLabData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const rows1 = iplabData.filter(item => item.lab_paid > 0).map(item => ({
        id: item.id,
        date_time: `${item.add_date_date} ${item.add_time}`,
        appt_id: item.appt_id,
        pat__pat_id: item.pat__pat_id,
        pat__patient: item.pat__patient,
        lab_invoice: item.lab_invoice,
        lab_tot: item.lab_tot,
        lab_paid: item.lab_paid,
        lab_balance: item.lab_balance,
        lab_pmode: item.lab_pmode,
        cashier: item.cashier,
    }));
    const columns = [
        {field: 'date_time', headerName: 'Date', width: 160},
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 200},
        {
            field: 'lab_invoice', headerName: 'Invoice No',
            renderCell: (params) => (
                <Link to={`/lab-invoice-op/${params.row.lab_invoice}`} target="_blank">
                    {params.row.lab_invoice}
                </Link>
            ),
            width: 120
        },
        {field: 'lab_tot', headerName: 'Invoiced Amount', width: 100},
        {field: 'lab_paid', headerName: 'Paid Amount', width: 100},
        {field: 'lab_balance', headerName: 'Balance', width: 100},
        {field: 'lab_pmode', headerName: 'Payment Mode', width: 110},
        {field: 'cashier', headerName: 'Cashier', width: 100},
    ];
    const columns1 = [
        {field: 'date_time', headerName: 'Date', width: 160},
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
        {field: 'pat__patient', headerName: 'Patient', width: 200},
        {
            field: 'lab_invoice', headerName: 'Invoice No',
            renderCell: (params) => (
                <Link to={`/lab-invoice-ip/${params.row.lab_invoice}`} target="_blank">
                    {params.row.lab_invoice}
                </Link>
            ),
            width: 120
        },
        {field: 'lab_tot', headerName: 'Invoiced Amount', width: 100},
        {field: 'lab_paid', headerName: 'Paid Amount', width: 100},
        {field: 'lab_balance', headerName: 'Balance', width: 100},
        {field: 'lab_pmode', headerName: 'Payment Mode', width: 110},
        {field: 'cashier', headerName: 'Cashier', width: 100},
    ];
    const getTotal = (rows, field) => {
        return rows.reduce((total, row) => total + parseFloat(row[field]), 0);
    };
    const Footer = ({rows}) => {
        const totalInvoicedAmount = getTotal(rows, 'lab_tot');
        const totalPaidAmount = getTotal(rows, 'lab_paid');
        const totalBalance = getTotal(rows, 'lab_balance');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>Invoice Amount: {totalInvoicedAmount}</div>
                <div>Paid Amount: {totalPaidAmount}</div>
                <div>Balance:{totalBalance}</div>
            </div>
        );
    };
    const getTotal1 = (rows1, field1) => {
        return rows1.reduce((total1, row1) => total1 + parseFloat(row1[field1]), 0);
    };
    const Footer1 = ({rows1}) => {
        const totalInvoicedAmount1 = getTotal1(rows1, 'lab_tot');
        const totalPaidAmount1 = getTotal1(rows1, 'lab_paid');
        const totalBalance1 = getTotal1(rows1, 'lab_balance');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>{totalInvoicedAmount1}</div>
                <div>{totalPaidAmount1}</div>
                <div>{totalBalance1}</div>
            </div>
        );
    };
    const today = new Date();
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> Lab Collection Report</h3>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="date-filter-container">
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChange}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                placeholderText="From Date"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                className="date-picker-input"
                            />

                            <DatePicker
                                selected={endDate}
                                onChange={handleEndDateChange}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                placeholderText="To Date"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                className="date-picker-input"
                            />
                        </div>

                    </div>
                </div>
            </div>

            {!isLoading && labData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}} className="mt-4">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                        className="fa-solid fa-calendar-days"
                        aria-hidden="true" style={{color: 'red'}}></i> OP Lab Collection Report</h3>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                              }}

                              autoHeight
                    />
                    <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                        <tfoot>
                        <Footer rows={rows}/>
                        </tfoot>
                    </table>
                </div>
            ) : (
                <>loading pls wait....</>
            )}<br></br>
            {!isLoading && iplabData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}} className="mt-4">
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                        className="fa-solid fa-calendar-days"
                        aria-hidden="true" style={{color: 'red'}}></i> IP Lab Collection Report</h3>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows1}
                              columns={columns1}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                              }}

                              autoHeight
                    />
                    <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                        <tfoot>
                        <Footer rows={rows1}/>
                        </tfoot>
                    </table>
                </div>
            ) : (
                <>loading pls wait....</>
            )}
        </section>
    )
}
export default CollectionLab;
